import { updateItems } from '@/mocks/homeData';

const typeStyles: Record<string, string> = {
  '数据': 'bg-accent-100 text-accent-700',
  '功能': 'bg-primary-100 text-primary-700',
  '更新': 'bg-secondary-100 text-secondary-700',
  '专题': 'bg-primary-100 text-primary-700',
  '合作': 'bg-accent-100 text-accent-700',
  '里程碑': 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-9">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">最新动态</h2>
          <p className="mt-2 text-sm text-foreground-500">天美影视的每一次进步，都与你有关</p>
        </div>
        <div className="max-w-2xl mx-auto">
          {updateItems.map((item, idx) => (
            <div
              key={item.id}
              className="flex gap-4"
            >
              <div className="flex flex-col items-center">
                <div className={`w-2 h-2 rounded-full mt-1.5 shrink-0 ${
                  idx === 0 ? 'bg-accent-500' : 'bg-background-300'
                }`}></div>
                {idx !== updateItems.length - 1 && (
                  <div className="w-px flex-1 bg-background-300 my-1"></div>
                )}
              </div>
              <div className={`pb-5 flex-1 ${idx === updateItems.length - 1 ? 'pb-0' : ''}`}>
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs font-medium text-foreground-500">{item.date}</span>
                  <span className={`px-1.5 py-0.5 text-[10px] font-medium rounded ${typeStyles[item.type] || 'bg-background-200 text-foreground-600'}`}>
                    {item.type}
                  </span>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}